import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

interface Filters {
  statehood?: string[];
  management?: string[];
  dateRange?: [string, string];
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private filtersMap = new BehaviorSubject<Filters>({});

  getFilters(contextKey: string): Observable<Filters> {
    return this.filtersMap.asObservable().pipe(
      map(filters => Object.prototype.hasOwnProperty.call(filters, contextKey) 
        ? filters[contextKey as keyof Filters] || {} 
        : {})
    );
  }

  setFilters(contextKey: string, filters: Filters): void {
    const current = this.filtersMap.value;
    this.filtersMap.next({ ...current, [contextKey]: filters });
  }

  getRawFilters(contextKey: string): any {
    const current = this.filtersMap.value;
    return Object.prototype.hasOwnProperty.call(current, contextKey)
      ? current[contextKey as keyof Filters] || {}
      : {};
  }

  clearAllFilters(): void {
    this.filtersMap.next({});
  }

}
